import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '附件',
    type: 'RULEM_RM_ATTACHMENT',
}
